window.mediaBanner = ({ source = "file", embed = "" } = {}) => ({
	started: false,
	paused: false,
	src: "about:blank",

	init() {
		if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
			this.paused = true;
			return;
		}

		this.start();
	},

	start() {
		this.started = true;

		if (source !== "file") {
			this.src = embed;
			return;
		}

		this.$nextTick(() => {
			this.$refs.video?.play()?.catch(() => {
				this.paused = true;
			});
		});
	},

	toggle() {
		this.paused = !this.paused;

		// First press on a video that was never started — load it and play.
		if (!this.paused && !this.started) {
			this.start();
			return;
		}

		if (source === "file") {
			if (this.paused) {
				this.$refs.video?.pause();
			} else {
				this.$refs.video?.play()?.catch(() => {
					this.paused = true;
				});
			}
			return;
		}

		this.post(this.paused ? "pause" : "play");
	},

	post(action) {
		const win = this.$refs.frame?.contentWindow;
		if (!win) return;

		const message =
			source === "youtube"
				? {
						event: "command",
						func: action === "pause" ? "pauseVideo" : "playVideo",
						args: [],
					}
				: { method: action };

		win.postMessage(JSON.stringify(message), "*");
	},
});
